/**
 * @import { RouteFeature } from '../types/route-feature'
 */

import { useMap } from '@vis.gl/react-google-maps';
import { useMemo } from 'react';
import { usePolyline } from '../hooks/use-polyline';
import { useShowArrow } from '../hooks/use-show-arrow';
import { highDetailMinZoom, useZoom } from '@/hooks/use-zoom';
import { createArrowIconSequence } from '../utils/icon';
import { zIndex } from '@/features/itinerary-map/utils/layer';

const lineColor = '#278edd';

/**
 * @param {object} props
 * @param {RouteFeature} props.feature
 * @returns {React.JSX.Element}
 */
export function AirplanePolyline({ feature }) {
  const map = useMap();
  const zoom = useZoom();
  const showArrow = useShowArrow(zoom, feature);

  const polylineOptions = useMemo(() => {
    if (!map) {
      return {};
    }

    return /** @type {google.maps.PolylineOptions} */ ({
      zIndex: zIndex.airplanePath,
      strokeColor: lineColor,
      icons: showArrow ? createArrowIconSequence(lineColor, highDetailMinZoom, zoom) : null,
      clickable: false,
    });
  }, [map, showArrow, zoom]);

  usePolyline(feature, polylineOptions);

  return <></>;
}
